<template>
    <div class="home-page">
		<Header></Header>
		<div class="">
			<div class="nav flex">
				<div class="back" @click="back">
					<img src="static/images/return.png" />
				</div>
				<span class="">{{$t('Ranking_Score')}}</span>
			</div>
			<div class="ranking-list">
				<div class="ranking-t fs26 flex flex-evenly">
<!--					<div class="w30" :class="{'active':isType==1}" @click="tabDay(1)">{{$t('Today')}}</div>-->
					<div class="w30" :class="{'active':isType==1}" @click="tabDay(1)">{{$t('Week_Rank')}}</div>
					<div class=" ac" :class="{'active':isType==2}" @click="tabDay(2)">{{$t('Monthly')}}</div>
				</div>
				<Loadmore :onLoadMore="onLoadMore" :enableLoadMore="enableLoadMore" :isLoadMore="isLoadMore">
					 <div slot="loadMore" >
						<div class="section-content">
							<div class="font-c bgf7f flex-between flex"  v-for="(item,index) in list">
								<div class="num num2 fs33" v-if="index+1==1"><i class="no1">1</i></div>
								<div class="num num2 fs33" v-if="index+1==2"><i class="no2">2</i></div>
								<div class="num num2 fs33" v-if="index+1==3"><i class="no3">3</i></div>
								<div class="num2 fs33" v-if="index+1!=1&&index+1!=2&&index+1!=3">{{index+1}}</div>
								<p class="title fs26 text-overflow2">{{item.nickname}}</p>
								<div class="next fs26">
									{{item.score}}
								</div>
							</div>
						</div>
					</div>
				</Loadmore>
			</div>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
import Loadmore from '../components/LoadMore'
export default {
    components:{
		Header,
		Loadmore
    },
    data() {
        return {
			notFound:false,
			list:[],
			page:1,
            enableLoadMore: true,
			isLoadMore:true,
			isType:1,

		}
    },
    mounted() {
		let that = this;
    },
	created(){
		this.getHome()
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		tabDay(type){
			this.page = 1
			this.isType = type;
			this.enableLoadMore = true
			this.isLoading = true
			this.getHome();
		},
		onLoadMore(done) {
            setTimeout(()=>{
                if(!this.enableLoadMore) {
					this.$utils.alertText(this.$t('no_data'),80);
                }
                this.page = this.page + 1
                this.getHome();
                done();
            }, 200)
        },
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			// let url = '/rank/month&page_id='+that.page+'&page_size=10'
			let url = '/rank/week?page_id='+that.page+'&page_size=10'
			if(this.isType==2){
				url = '/rank/quarter?page_id='+that.page+'&page_size=10'
			}
			that.$api.post(url,null,r =>{
				that.$parent.returnCode(r,function(){
					if(that.page==1){
						if(r.data.list.length<10){
							that.isLoadMore = false;
						}
						that.list = r.data.list
					}else{
						that.isLoadMore = true;
						if(r.data.list.length == 0) {
							that.enableLoadMore = false
						}
						that.list = that.list.concat(r.data.list)
					}
					that.$parent.loadModal(false);
                });

			})
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/ranking.vue